import React from "react";
import { AppTranslation } from "../../../../../i18n/useAppTranslation";

export const PaperworkHeader = ({ children }) => {
  return (
    <div className="setting-setion m-b-10">
      <div className="membership-title">
        <AppTranslation.Common path="label.patient" /> Paperwork
        <div className="memberRightActions">{children}</div>
      </div>
    </div>
  );
};
